import React from 'react';
import {useEffect} from 'react';
import {useState} from 'react';
import {useParams} from 'react-router-dom';
import notFound from './../../assets/images/user_not_found.svg';
import {TailSpin} from 'react-loader-spinner';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useRequest from './../../API/request';
import UserPublicProfile from './../UserPublicProfile/UserPublicProfile';
import MetaTagWrapper from './../../components/MetaTagWrapper';
import useWindowWidth from '../../hooks/useWindowWidth';


const PublicPage = (): JSX.Element => {
  const [publicUser, setPublicUser] = useState(undefined) as any;
  const [message, setMessage] = useState<string>('Loading...');
  const mobile = useWindowWidth();
  const params: {username: string} = useParams();
  const request = useRequest({method: 'GET', url: '/user/public'});

  const getMediakitUser = async () => {
    const credentials = {
      nickname: params?.username,
    };
    const result = await request.doRequest({...credentials});

    if (result) {
      if (result?.mediakitUser?.id) {
        const mediakitUser = {...result.mediakitUser};
        setPublicUser(mediakitUser);
      } else if (result.status === 404) {
        setMessage(result.message);
      }
    } else {
      setMessage('Something went wrong.');
    }
  };

  useEffect(() => {
    getMediakitUser();
  }, []);

  const meta = {
    title: publicUser?.fullname,
    description: publicUser?.bio,
    metaProperties: {
        ogImage: publicUser?.avatar?.url || "/social_image.png",
      },
    };

  const CustomLoader = (
    <div style={{width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
      <TailSpin color="#EB3B5A" height={80} width={80} />
    </div>
  );

  return (
    <>
      <MetaTagWrapper {...meta} />
      {publicUser === undefined ? (
        <div>
          {message !== 'Loading...' ? <img src={notFound} />:CustomLoader }
        </div>
      ) : (
        <>
          <UserPublicProfile
            mediakitUser={{...publicUser, nickname: params?.username}}
            themeProp={{}}
          />
          {mobile < 668 ? (
              <ToastContainer
                position="top-center"
                autoClose={1600}
                style={{padding: `20px`, marginBottom: `220px`}}
              />
            ) : (
              <ToastContainer position="bottom-right" autoClose={6600} />
            )}
        </>
      )}
    </>
  );
};

export default PublicPage;
